export default "__VITE_ASSET__3aGGTFdV__"